module.exports = __webpack_public_path__ + "media/images/recruitment/inspired-photo-96bb2a2519a6a26b35cef30506ee5b3c.jpg";